import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import { useLoggedUser } from '@btime/react-session'

const Context = React.createContext([])
const { Provider } = Context
export const useUserState = () => React.useContext(Context)
export const useUser = () => useUserState()?.user

const QUERY = gql`
  query User($id: ID) {
    user(id: $id, filter: {}) {
      id
      name
      email
      superlogicaToken
      canAccessPaymentModule
    }
  }
`

const UserLoader = ({ children }) => {
  const { id } = useLoggedUser()
  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    skip: !id,
    client: accountsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default UserLoader
